export const About = (props) => {
  return (
    <section>
    <div id="about" className="about-section">
    <div className="container-fluid">
      <div className="min">
        <div className="col-md-6"> <img src="img/about2.png" alt="kent" loading="lazy" className="img-responsive" /> </div>
        <div className="col-md-6">
          <div className="why-kent">
            <h2>Why RO Water Purifier Need Regular Service</h2>
            <p>We provide reliable and professional RO water purifier repair services for all major brands. Our experienced technicians ensure quick diagnosis, genuine spare parts, and long-lasting solutions.</p>
            <p>Services include RO repair, servicing, filter replacement, membrane change, installation, and annual maintenance contracts (AMC). We focus on quality workmanship, transparent pricing, and timely service to ensure safe and pure drinking water for your home or office.</p>
            <a href="tel: 01169269790 " onclick="return gtag_report_conversion('tel: 01169269790 ')" className="cls">Get in Touch →</a> </div>
        </div>
      </div>
    </div>
    </div>
    </section>
  );
};
